import type { CampaignUserDto } from '@signalvote/shared';

const NO_STAFF: readonly CampaignUserDto[] = [];

/** The staff once their read has answered, else none: for pickers that only offer people to choose. */
export function readyStaff(read: { status: string; data?: CampaignUserDto[] }): CampaignUserDto[] {
  return read.status === 'ready' && read.data ? read.data : (NO_STAFF as CampaignUserDto[]);
}

/** What to say in place of the staff when their read has not answered; null once it has, or while it loads. */
export function staffUnreadyMessage(read: { status: string }): string | null {
  if (read.status === 'offline') return "You're offline, so the staff list can't load.";
  if (read.status === 'failed') return "Couldn't load staff. Try again shortly.";
  return null;
}
